import React from 'react';
import { COLUMN_1, COMPOSITE_1 } from 'Components/frameworks/card/Card.constants';
import { mapColToCard } from 'Components/utils/cards/cards.utils';
import { Card } from 'Components/frameworks/card/Card';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
type Props = {
  columns: Array<CMSCard>;
  displayLoadMore: boolean;
  hasFullScreenMode?: boolean;
  id?: string;
};
export const MediaTextVerticalLine = ({
  columns = [],
  displayLoadMore,
  hasFullScreenMode,
  id,
}: Props) => {
  if (!columns.length) {
    return null;
  }

  return (
    <SiteContainer className="Line" id={id}>
      {columns.length > 1 ? (
        <div className="grid grid-cols-1 gap-x-20 gap-y-40 sm:grid-cols-2">
          {columns.map((col) => {
            return (
              <Card
                {...mapColToCard({ ...col })}
                displayLoadMore={displayLoadMore}
                key={col.title}
                hasFullScreenMode={hasFullScreenMode}
                layout={COLUMN_1}
              />
            );
          })}
        </div>
      ) : (
        <Card
          {...mapColToCard({ ...columns[0] })}
          hasFullScreenMode={hasFullScreenMode}
          displayLoadMore={displayLoadMore}
          layout={COMPOSITE_1}
        />
      )}
    </SiteContainer>
  );
};
